import axios from 'axios';

export const checkCoupon = async (code) => {
  const result = await axios.get(
    `${process.env.REACT_APP_YEARLY_SUBSCRIPTIONS}/coupons/${code}`,
  );
  return result.data;
};
